/* eslint-disable -- no need */
import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
export type CartItemConfigurationFragment = {
  __typename?: 'CartItemConfiguration';
  initialBalance?: number | null;
  payoutFrequency?: number | null;
  leverage?: number | null;
  profitSplit?: number | null;
  addons: Array<string>;
  trackingModel?: string | null;
  trackingModelVersion?: string | null;
};

export type CartItemFragment = {
  __typename?: 'CartItem';
  productType: string;
  productId: string;
  quantity: number;
  unitPrice?: number | null;
  totalPrice?: number | null;
  name?: string | null;
  configuration?: {
    __typename?: 'CartItemConfiguration';
    initialBalance?: number | null;
    payoutFrequency?: number | null;
    leverage?: number | null;
    profitSplit?: number | null;
    addons: Array<string>;
    trackingModel?: string | null;
    trackingModelVersion?: string | null;
  } | null;
};

export type CartFragment = {
  __typename?: 'Cart';
  id: string;
  status: CartStatus;
  appliedCouponCode?: string | null;
  metadata: any;
  createdAt: string;
  updatedAt?: string | null;
  paymentCurrency: string;
  exchangeRate: number;
  items: Array<{
    __typename?: 'CartItem';
    productType: string;
    productId: string;
    quantity: number;
    unitPrice?: number | null;
    totalPrice?: number | null;
    name?: string | null;
    configuration?: {
      __typename?: 'CartItemConfiguration';
      initialBalance?: number | null;
      payoutFrequency?: number | null;
      leverage?: number | null;
      profitSplit?: number | null;
      addons: Array<string>;
      trackingModel?: string | null;
      trackingModelVersion?: string | null;
    } | null;
  }>;
  baseItemsTotal: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  baseDiscountAmount: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  baseFinalTotal: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  paymentItemsTotal: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  paymentDiscountAmount: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  paymentFinalTotal: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  appliedDiscount?: {
    __typename?: 'CouponDiscount';
    couponCodeRequested: string;
    couponCodeProcessed?: string | null;
    couponDiscount?: number | null;
    couponConfig?: {
      __typename?: 'CouponConfig';
      discountType: string;
      amountType: AmountType;
      amount: number;
    } | null;
  } | null;
};

export type CouponConfigFragment = {
  __typename?: 'CouponConfig';
  discountType: string;
  amountType: AmountType;
  amount: number;
};

export type CouponDiscountFragment = {
  __typename?: 'CouponDiscount';
  couponCodeRequested: string;
  couponCodeProcessed?: string | null;
  couponDiscount?: number | null;
  couponConfig?: {
    __typename?: 'CouponConfig';
    discountType: string;
    amountType: AmountType;
    amount: number;
  } | null;
};

export type CurrencyAmountFragment = {
  __typename?: 'CurrencyAmount';
  amount: number;
  currency: string;
};

export type LoginResponseFragment = {
  __typename?: 'LoginResponse';
  success: boolean;
  message: string;
  accessToken?: string | null;
  refreshToken?: string | null;
  clientIp: string;
  user?: {
    __typename?: 'UserInfo';
    id: string;
    email: string;
    roles: Array<string>;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    preferredLocale?: string | null;
    countryCode?: string | null;
  } | null;
};

export type OrderBillingAddressFragment = {
  __typename?: 'OrderBillingAddress';
  street1: string;
  street2?: string | null;
  city: string;
  state?: string | null;
  postalCode: string;
  country: string;
  countryName?: string | null;
};

export type OrderCustomerSnapshotFragment = {
  __typename?: 'OrderCustomerSnapshot';
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  company?: string | null;
  phone?: string | null;
  vatNumber?: string | null;
  marketingConsent: boolean;
  termsAccepted: boolean;
  capturedAt?: string | null;
  billingAddress?: {
    __typename?: 'OrderBillingAddress';
    street1: string;
    street2?: string | null;
    city: string;
    state?: string | null;
    postalCode: string;
    country: string;
    countryName?: string | null;
  } | null;
};

export type OrderPaymentFragment = {
  __typename?: 'OrderPayment';
  id: string;
  orderId: string;
  paymentReference: string;
  sequenceNumber: number;
  amount: number;
  currency: string;
  paymentGateway: PaymentGatewayEnum;
  paymentProcessor?: string | null;
  paymentStatus: PaymentStatusEnum;
  gatewayStatus?: string | null;
  gatewayUrl?: string | null;
};

export type OrderFragment = {
  __typename?: 'Order';
  id: string;
  orderNumber: string;
  userId: string;
  cartId: string;
  status: OrderStatus;
  paymentCurrency: string;
  exchangeRate: number;
  appliedCouponCode?: string | null;
  paymentHash: string;
  fulfillmentStatus: FulfillmentStatus;
  fulfillmentMetadata?: any | null;
  metadata?: any | null;
  completedAt?: string | null;
  cancelledAt?: string | null;
  expiresAt?: string | null;
  createdAt: string;
  updatedAt?: string | null;
  items: Array<{
    __typename?: 'CartItem';
    productType: string;
    productId: string;
    quantity: number;
    unitPrice?: number | null;
    totalPrice?: number | null;
    name?: string | null;
    configuration?: {
      __typename?: 'CartItemConfiguration';
      initialBalance?: number | null;
      payoutFrequency?: number | null;
      leverage?: number | null;
      profitSplit?: number | null;
      addons: Array<string>;
      trackingModel?: string | null;
      trackingModelVersion?: string | null;
    } | null;
  }>;
  baseItemsTotal: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  baseDiscountAmount: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  baseFinalTotal: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  paymentItemsTotal: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  paymentDiscountAmount: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  paymentFinalTotal: {
    __typename?: 'CurrencyAmount';
    amount: number;
    currency: string;
  };
  appliedDiscount?: {
    __typename?: 'CouponDiscount';
    couponCodeRequested: string;
    couponCodeProcessed?: string | null;
    couponDiscount?: number | null;
    couponConfig?: {
      __typename?: 'CouponConfig';
      discountType: string;
      amountType: AmountType;
      amount: number;
    } | null;
  } | null;
  customerSnapshot: {
    __typename?: 'OrderCustomerSnapshot';
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    company?: string | null;
    phone?: string | null;
    vatNumber?: string | null;
    marketingConsent: boolean;
    termsAccepted: boolean;
    capturedAt?: string | null;
    billingAddress?: {
      __typename?: 'OrderBillingAddress';
      street1: string;
      street2?: string | null;
      city: string;
      state?: string | null;
      postalCode: string;
      country: string;
      countryName?: string | null;
    } | null;
  };
};

export type PayoutFragment = {
  __typename?: 'Payout';
  status: PayoutStatusEnum;
  withdrawalAmount: number;
  createdAt: string;
};

export type PlaceOrderResponseFragment = {
  __typename?: 'PlaceOrderResponse';
  payment?: {
    __typename?: 'OrderPayment';
    id: string;
    orderId: string;
    paymentReference: string;
    sequenceNumber: number;
    amount: number;
    currency: string;
    paymentGateway: PaymentGatewayEnum;
    paymentProcessor?: string | null;
    paymentStatus: PaymentStatusEnum;
    gatewayStatus?: string | null;
    gatewayUrl?: string | null;
  } | null;
  order?: {
    __typename?: 'Order';
    id: string;
    orderNumber: string;
    userId: string;
    cartId: string;
    status: OrderStatus;
    paymentCurrency: string;
    exchangeRate: number;
    appliedCouponCode?: string | null;
    paymentHash: string;
    fulfillmentStatus: FulfillmentStatus;
    fulfillmentMetadata?: any | null;
    metadata?: any | null;
    completedAt?: string | null;
    cancelledAt?: string | null;
    expiresAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    items: Array<{
      __typename?: 'CartItem';
      productType: string;
      productId: string;
      quantity: number;
      unitPrice?: number | null;
      totalPrice?: number | null;
      name?: string | null;
      configuration?: {
        __typename?: 'CartItemConfiguration';
        initialBalance?: number | null;
        payoutFrequency?: number | null;
        leverage?: number | null;
        profitSplit?: number | null;
        addons: Array<string>;
        trackingModel?: string | null;
        trackingModelVersion?: string | null;
      } | null;
    }>;
    baseItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    appliedDiscount?: {
      __typename?: 'CouponDiscount';
      couponCodeRequested: string;
      couponCodeProcessed?: string | null;
      couponDiscount?: number | null;
      couponConfig?: {
        __typename?: 'CouponConfig';
        discountType: string;
        amountType: AmountType;
        amount: number;
      } | null;
    } | null;
    customerSnapshot: {
      __typename?: 'OrderCustomerSnapshot';
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      company?: string | null;
      phone?: string | null;
      vatNumber?: string | null;
      marketingConsent: boolean;
      termsAccepted: boolean;
      capturedAt?: string | null;
      billingAddress?: {
        __typename?: 'OrderBillingAddress';
        street1: string;
        street2?: string | null;
        city: string;
        state?: string | null;
        postalCode: string;
        country: string;
        countryName?: string | null;
      } | null;
    };
  } | null;
};

export type TradingAccountDailyMetricsFragment = {
  __typename?: 'TradingAccountDailyMetrics';
  id?: number | null;
  tradingAccountId: string;
  year: number;
  month: number;
  day: number;
  startingBalance: number;
  startingEquity: number;
  endingBalance?: number | null;
  endingEquity?: number | null;
  tradesExecuted?: number | null;
  lotsExecuted?: number | null;
  withdrawals?: number | null;
  createdAt: string;
  note?: string | null;
};

export type TradingAccountHistoryFragment = {
  __typename?: 'TradingAccountHistory';
  id?: string | null;
  tradingAccountId: string;
  positionId: string;
  platform?: string | null;
  symbol: string;
  dateOpenUtc: string;
  dateCloseUtc: string;
  holdTime: number;
  action: TradingAccountPositionAction;
  swaps: number;
  commissions: number;
  fees: number;
  lots: number;
  profit: number;
  profitPercentage: number;
  netProfit: number;
  openPrice: number;
  closePrice: number;
  note?: string | null;
};

export type TradingAccountFragment = {
  __typename?: 'TradingAccount';
  id: string;
  name?: string | null;
  platform: TradingAccountPlatformEnum;
  number: string;
  initialBalance?: number | null;
  equity?: number | null;
  balance?: number | null;
  status: TradingAccountStatusEnum;
  trackingModel?: string | null;
  snapshot?: any | null;
  masterPassword?: string | null;
  investorPassword?: string | null;
  createdAt?: string | null;
  parameters?: {
    __typename?: 'TradingAccountChallengeParameters';
    profitSplitAmount?: number | null;
    payoutFrequency?: number | null;
    leverage?: number | null;
  } | null;
};

export type UserInfoFragment = {
  __typename?: 'UserInfo';
  id: string;
  email: string;
  roles: Array<string>;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  preferredLocale?: string | null;
  countryCode?: string | null;
};

export type AcceptRiskTermsForAllocationMutationVariables = Exact<{
  input: AcceptRiskTermsInput;
}>;

export type AcceptRiskTermsForAllocationMutation = {
  __typename?: 'Mutation';
  acceptRiskTerms: {
    __typename?: 'AcceptRiskTermsResponse';
    success: boolean;
    message: string;
  };
};

export type AddDiscountToCartMutationVariables = Exact<{
  cartId?: InputMaybe<Scalars['String']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  paymentCurrency?: InputMaybe<Scalars['String']['input']>;
  utmData?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type AddDiscountToCartMutation = {
  __typename?: 'Mutation';
  addDiscountToCart: {
    __typename?: 'Cart';
    id: string;
    status: CartStatus;
    appliedCouponCode?: string | null;
    metadata: any;
    createdAt: string;
    updatedAt?: string | null;
    paymentCurrency: string;
    exchangeRate: number;
    items: Array<{
      __typename?: 'CartItem';
      productType: string;
      productId: string;
      quantity: number;
      unitPrice?: number | null;
      totalPrice?: number | null;
      name?: string | null;
      configuration?: {
        __typename?: 'CartItemConfiguration';
        initialBalance?: number | null;
        payoutFrequency?: number | null;
        leverage?: number | null;
        profitSplit?: number | null;
        addons: Array<string>;
        trackingModel?: string | null;
        trackingModelVersion?: string | null;
      } | null;
    }>;
    baseItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    appliedDiscount?: {
      __typename?: 'CouponDiscount';
      couponCodeRequested: string;
      couponCodeProcessed?: string | null;
      couponDiscount?: number | null;
      couponConfig?: {
        __typename?: 'CouponConfig';
        discountType: string;
        amountType: AmountType;
        amount: number;
      } | null;
    } | null;
  };
};

export type AddProductToCartMutationVariables = Exact<{
  cartId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  paymentCurrency?: InputMaybe<Scalars['String']['input']>;
  utmData?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type AddProductToCartMutation = {
  __typename?: 'Mutation';
  addProductToCart: {
    __typename?: 'Cart';
    id: string;
    status: CartStatus;
    appliedCouponCode?: string | null;
    metadata: any;
    createdAt: string;
    updatedAt?: string | null;
    paymentCurrency: string;
    exchangeRate: number;
    items: Array<{
      __typename?: 'CartItem';
      productType: string;
      productId: string;
      quantity: number;
      unitPrice?: number | null;
      totalPrice?: number | null;
      name?: string | null;
      configuration?: {
        __typename?: 'CartItemConfiguration';
        initialBalance?: number | null;
        payoutFrequency?: number | null;
        leverage?: number | null;
        profitSplit?: number | null;
        addons: Array<string>;
        trackingModel?: string | null;
        trackingModelVersion?: string | null;
      } | null;
    }>;
    baseItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    appliedDiscount?: {
      __typename?: 'CouponDiscount';
      couponCodeRequested: string;
      couponCodeProcessed?: string | null;
      couponDiscount?: number | null;
      couponConfig?: {
        __typename?: 'CouponConfig';
        discountType: string;
        amountType: AmountType;
        amount: number;
      } | null;
    } | null;
  };
};

export type CreateAccountWithdrawalMutationVariables = Exact<{
  input: CreateAccountWithdrawalInput;
}>;

export type CreateAccountWithdrawalMutation = {
  __typename?: 'Mutation';
  createAccountWithdrawal: {
    __typename?: 'AccountWithdrawalResult';
    payoutId: string;
    status: TradingAccountPayoutStatusEnum;
    withdrawalAmount: number;
    totalToPayAmount: number;
    profitSplitAmount: number;
    message: string;
  };
};

export type CreatePayoutMethodMutationVariables = Exact<{
  input: CreatePayoutMethodInput;
}>;

export type CreatePayoutMethodMutation = {
  __typename?: 'Mutation';
  createPayoutMethod: {
    __typename?: 'PayoutMethod';
    id: string;
    type: PayoutMethodTypeEnum;
    name: string;
    displayName?: string | null;
    status: PayoutMethodStatusEnum;
    isDefault: boolean;
    configuration: any;
    createdAt: string;
  };
};

export type ImpersonateUserMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;

export type ImpersonateUserMutation = {
  __typename?: 'Mutation';
  impersonate: {
    __typename?: 'LoginResponse';
    success: boolean;
    message: string;
    accessToken?: string | null;
    refreshToken?: string | null;
    clientIp: string;
    user?: {
      __typename?: 'UserInfo';
      id: string;
      email: string;
      roles: Array<string>;
      firstName?: string | null;
      middleName?: string | null;
      lastName?: string | null;
      preferredLocale?: string | null;
      countryCode?: string | null;
    } | null;
  };
};

export type LoginUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type LoginUserMutation = {
  __typename?: 'Mutation';
  login: {
    __typename?: 'LoginResponse';
    success: boolean;
    message: string;
    accessToken?: string | null;
    refreshToken?: string | null;
    clientIp: string;
    user?: {
      __typename?: 'UserInfo';
      id: string;
      email: string;
      roles: Array<string>;
      firstName?: string | null;
      middleName?: string | null;
      lastName?: string | null;
      preferredLocale?: string | null;
      countryCode?: string | null;
    } | null;
  };
};

export type PlaceOrderMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  customerSnapshot: OrderCustomerSnapshotInput;
  paymentGateway?: InputMaybe<PaymentGatewayEnum>;
  affiliateCode?: InputMaybe<Scalars['String']['input']>;
  adminOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type PlaceOrderMutation = {
  __typename?: 'Mutation';
  placeOrder: {
    __typename?: 'PlaceOrderResponse';
    payment?: {
      __typename?: 'OrderPayment';
      id: string;
      orderId: string;
      paymentReference: string;
      sequenceNumber: number;
      amount: number;
      currency: string;
      paymentGateway: PaymentGatewayEnum;
      paymentProcessor?: string | null;
      paymentStatus: PaymentStatusEnum;
      gatewayStatus?: string | null;
      gatewayUrl?: string | null;
    } | null;
    order?: {
      __typename?: 'Order';
      id: string;
      orderNumber: string;
      userId: string;
      cartId: string;
      status: OrderStatus;
      paymentCurrency: string;
      exchangeRate: number;
      appliedCouponCode?: string | null;
      paymentHash: string;
      fulfillmentStatus: FulfillmentStatus;
      fulfillmentMetadata?: any | null;
      metadata?: any | null;
      completedAt?: string | null;
      cancelledAt?: string | null;
      expiresAt?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      items: Array<{
        __typename?: 'CartItem';
        productType: string;
        productId: string;
        quantity: number;
        unitPrice?: number | null;
        totalPrice?: number | null;
        name?: string | null;
        configuration?: {
          __typename?: 'CartItemConfiguration';
          initialBalance?: number | null;
          payoutFrequency?: number | null;
          leverage?: number | null;
          profitSplit?: number | null;
          addons: Array<string>;
          trackingModel?: string | null;
          trackingModelVersion?: string | null;
        } | null;
      }>;
      baseItemsTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      baseDiscountAmount: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      baseFinalTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      paymentItemsTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      paymentDiscountAmount: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      paymentFinalTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      appliedDiscount?: {
        __typename?: 'CouponDiscount';
        couponCodeRequested: string;
        couponCodeProcessed?: string | null;
        couponDiscount?: number | null;
        couponConfig?: {
          __typename?: 'CouponConfig';
          discountType: string;
          amountType: AmountType;
          amount: number;
        } | null;
      } | null;
      customerSnapshot: {
        __typename?: 'OrderCustomerSnapshot';
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        company?: string | null;
        phone?: string | null;
        vatNumber?: string | null;
        marketingConsent: boolean;
        termsAccepted: boolean;
        capturedAt?: string | null;
        billingAddress?: {
          __typename?: 'OrderBillingAddress';
          street1: string;
          street2?: string | null;
          city: string;
          state?: string | null;
          postalCode: string;
          country: string;
          countryName?: string | null;
        } | null;
      };
    } | null;
  };
};

export type RegisterUserMutationVariables = Exact<{
  input: RegisterUserInput;
}>;

export type RegisterUserMutation = {
  __typename?: 'Mutation';
  register: {
    __typename?: 'LoginResponse';
    success: boolean;
    message: string;
    accessToken?: string | null;
    refreshToken?: string | null;
    clientIp: string;
    user?: {
      __typename?: 'UserInfo';
      id: string;
      email: string;
      roles: Array<string>;
      firstName?: string | null;
      middleName?: string | null;
      lastName?: string | null;
      preferredLocale?: string | null;
      countryCode?: string | null;
    } | null;
  };
};

export type RenewInstantFundingMutationVariables = Exact<{
  accountNumber: Scalars['String']['input'];
  paymentGateway: PaymentGatewayEnum;
  paymentHash?: InputMaybe<Scalars['String']['input']>;
}>;

export type RenewInstantFundingMutation = {
  __typename?: 'Mutation';
  renewInstantFunding: {
    __typename?: 'PlaceOrderResponse';
    payment?: {
      __typename?: 'OrderPayment';
      id: string;
      orderId: string;
      paymentReference: string;
      sequenceNumber: number;
      amount: number;
      currency: string;
      paymentGateway: PaymentGatewayEnum;
      paymentProcessor?: string | null;
      paymentStatus: PaymentStatusEnum;
      gatewayStatus?: string | null;
      gatewayUrl?: string | null;
    } | null;
    order?: {
      __typename?: 'Order';
      id: string;
      orderNumber: string;
      userId: string;
      cartId: string;
      status: OrderStatus;
      paymentCurrency: string;
      exchangeRate: number;
      appliedCouponCode?: string | null;
      paymentHash: string;
      fulfillmentStatus: FulfillmentStatus;
      fulfillmentMetadata?: any | null;
      metadata?: any | null;
      completedAt?: string | null;
      cancelledAt?: string | null;
      expiresAt?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      items: Array<{
        __typename?: 'CartItem';
        productType: string;
        productId: string;
        quantity: number;
        unitPrice?: number | null;
        totalPrice?: number | null;
        name?: string | null;
        configuration?: {
          __typename?: 'CartItemConfiguration';
          initialBalance?: number | null;
          payoutFrequency?: number | null;
          leverage?: number | null;
          profitSplit?: number | null;
          addons: Array<string>;
          trackingModel?: string | null;
          trackingModelVersion?: string | null;
        } | null;
      }>;
      baseItemsTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      baseDiscountAmount: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      baseFinalTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      paymentItemsTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      paymentDiscountAmount: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      paymentFinalTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      appliedDiscount?: {
        __typename?: 'CouponDiscount';
        couponCodeRequested: string;
        couponCodeProcessed?: string | null;
        couponDiscount?: number | null;
        couponConfig?: {
          __typename?: 'CouponConfig';
          discountType: string;
          amountType: AmountType;
          amount: number;
        } | null;
      } | null;
      customerSnapshot: {
        __typename?: 'OrderCustomerSnapshot';
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        company?: string | null;
        phone?: string | null;
        vatNumber?: string | null;
        marketingConsent: boolean;
        termsAccepted: boolean;
        capturedAt?: string | null;
        billingAddress?: {
          __typename?: 'OrderBillingAddress';
          street1: string;
          street2?: string | null;
          city: string;
          state?: string | null;
          postalCode: string;
          country: string;
          countryName?: string | null;
        } | null;
      };
    } | null;
  };
};

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type RequestPasswordResetMutation = {
  __typename?: 'Mutation';
  requestPasswordReset: {
    __typename?: 'PasswordResetResponse';
    success: boolean;
    message: string;
  };
};

export type RequestPaymentForOrderMutationVariables = Exact<{
  orderNumber: Scalars['String']['input'];
  paymentGateway: PaymentGatewayEnum;
  paymentHash?: InputMaybe<Scalars['String']['input']>;
}>;

export type RequestPaymentForOrderMutation = {
  __typename?: 'Mutation';
  requestPaymentForOrder: {
    __typename?: 'PlaceOrderResponse';
    payment?: {
      __typename?: 'OrderPayment';
      id: string;
      orderId: string;
      paymentReference: string;
      sequenceNumber: number;
      amount: number;
      currency: string;
      paymentGateway: PaymentGatewayEnum;
      paymentProcessor?: string | null;
      paymentStatus: PaymentStatusEnum;
      gatewayStatus?: string | null;
      gatewayUrl?: string | null;
    } | null;
    order?: {
      __typename?: 'Order';
      id: string;
      orderNumber: string;
      userId: string;
      cartId: string;
      status: OrderStatus;
      paymentCurrency: string;
      exchangeRate: number;
      appliedCouponCode?: string | null;
      paymentHash: string;
      fulfillmentStatus: FulfillmentStatus;
      fulfillmentMetadata?: any | null;
      metadata?: any | null;
      completedAt?: string | null;
      cancelledAt?: string | null;
      expiresAt?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      items: Array<{
        __typename?: 'CartItem';
        productType: string;
        productId: string;
        quantity: number;
        unitPrice?: number | null;
        totalPrice?: number | null;
        name?: string | null;
        configuration?: {
          __typename?: 'CartItemConfiguration';
          initialBalance?: number | null;
          payoutFrequency?: number | null;
          leverage?: number | null;
          profitSplit?: number | null;
          addons: Array<string>;
          trackingModel?: string | null;
          trackingModelVersion?: string | null;
        } | null;
      }>;
      baseItemsTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      baseDiscountAmount: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      baseFinalTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      paymentItemsTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      paymentDiscountAmount: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      paymentFinalTotal: {
        __typename?: 'CurrencyAmount';
        amount: number;
        currency: string;
      };
      appliedDiscount?: {
        __typename?: 'CouponDiscount';
        couponCodeRequested: string;
        couponCodeProcessed?: string | null;
        couponDiscount?: number | null;
        couponConfig?: {
          __typename?: 'CouponConfig';
          discountType: string;
          amountType: AmountType;
          amount: number;
        } | null;
      } | null;
      customerSnapshot: {
        __typename?: 'OrderCustomerSnapshot';
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        company?: string | null;
        phone?: string | null;
        vatNumber?: string | null;
        marketingConsent: boolean;
        termsAccepted: boolean;
        capturedAt?: string | null;
        billingAddress?: {
          __typename?: 'OrderBillingAddress';
          street1: string;
          street2?: string | null;
          city: string;
          state?: string | null;
          postalCode: string;
          country: string;
          countryName?: string | null;
        } | null;
      };
    } | null;
  };
};

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  resetPassword: {
    __typename?: 'LoginResponse';
    success: boolean;
    message: string;
    accessToken?: string | null;
    refreshToken?: string | null;
    clientIp: string;
    user?: {
      __typename?: 'UserInfo';
      id: string;
      email: string;
      roles: Array<string>;
      firstName?: string | null;
      middleName?: string | null;
      lastName?: string | null;
      preferredLocale?: string | null;
      countryCode?: string | null;
    } | null;
  };
};

export type StartKycSessionMutationVariables = Exact<{
  input: StartKycInput;
}>;

export type StartKycSessionMutation = {
  __typename?: 'Mutation';
  startKYCSession: {
    __typename?: 'StartKYCResponse';
    success: boolean;
    message: string;
    redirectUrl?: string | null;
  };
};

export type ValidatePasswordResetTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type ValidatePasswordResetTokenMutation = {
  __typename?: 'Mutation';
  validatePasswordResetToken: {
    __typename?: 'PasswordResetResponse';
    success: boolean;
    message: string;
  };
};

export type ChatAuthQueryVariables = Exact<{ [key: string]: never }>;

export type ChatAuthQuery = {
  __typename?: 'Query';
  authorizeTradingAi: { __typename?: 'AiTokenResponse'; token: string };
};

export type GetBrokerAccountQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;

export type GetBrokerAccountQuery = {
  __typename?: 'Query';
  tradingAccount: {
    __typename?: 'TradingAccount';
    id: string;
    name?: string | null;
    platform: TradingAccountPlatformEnum;
    number: string;
    initialBalance?: number | null;
    equity?: number | null;
    balance?: number | null;
    status: TradingAccountStatusEnum;
    trackingModel?: string | null;
    snapshot?: any | null;
    masterPassword?: string | null;
    investorPassword?: string | null;
    createdAt?: string | null;
    parameters?: {
      __typename?: 'TradingAccountChallengeParameters';
      profitSplitAmount?: number | null;
      payoutFrequency?: number | null;
      leverage?: number | null;
    } | null;
  };
};

export type GetBrokerAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type GetBrokerAccountsQuery = {
  __typename?: 'Query';
  tradingAccounts: Array<{
    __typename?: 'TradingAccount';
    id: string;
    name?: string | null;
    platform: TradingAccountPlatformEnum;
    number: string;
    initialBalance?: number | null;
    equity?: number | null;
    balance?: number | null;
    status: TradingAccountStatusEnum;
    trackingModel?: string | null;
    snapshot?: any | null;
    masterPassword?: string | null;
    investorPassword?: string | null;
    createdAt?: string | null;
    parameters?: {
      __typename?: 'TradingAccountChallengeParameters';
      profitSplitAmount?: number | null;
      payoutFrequency?: number | null;
      leverage?: number | null;
    } | null;
  }>;
};

export type GetSpecificKycStatusQueryVariables = Exact<{
  verificationId: Scalars['ID']['input'];
}>;

export type GetSpecificKycStatusQuery = {
  __typename?: 'Query';
  getKYCStatus: {
    __typename?: 'KYCStatusResponse';
    verificationId?: string | null;
    status: string;
    canStartSession: boolean;
    createdAt?: string | null;
    completedAt?: string | null;
  };
};

export type GetOrderQueryVariables = Exact<{
  orderNumber: Scalars['String']['input'];
  paymentHash?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOrderQuery = {
  __typename?: 'Query';
  order: {
    __typename?: 'Order';
    id: string;
    orderNumber: string;
    userId: string;
    cartId: string;
    status: OrderStatus;
    paymentCurrency: string;
    exchangeRate: number;
    appliedCouponCode?: string | null;
    paymentHash: string;
    fulfillmentStatus: FulfillmentStatus;
    fulfillmentMetadata?: any | null;
    metadata?: any | null;
    completedAt?: string | null;
    cancelledAt?: string | null;
    expiresAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    items: Array<{
      __typename?: 'CartItem';
      productType: string;
      productId: string;
      quantity: number;
      unitPrice?: number | null;
      totalPrice?: number | null;
      name?: string | null;
      configuration?: {
        __typename?: 'CartItemConfiguration';
        initialBalance?: number | null;
        payoutFrequency?: number | null;
        leverage?: number | null;
        profitSplit?: number | null;
        addons: Array<string>;
        trackingModel?: string | null;
        trackingModelVersion?: string | null;
      } | null;
    }>;
    baseItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    appliedDiscount?: {
      __typename?: 'CouponDiscount';
      couponCodeRequested: string;
      couponCodeProcessed?: string | null;
      couponDiscount?: number | null;
      couponConfig?: {
        __typename?: 'CouponConfig';
        discountType: string;
        amountType: AmountType;
        amount: number;
      } | null;
    } | null;
    customerSnapshot: {
      __typename?: 'OrderCustomerSnapshot';
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      company?: string | null;
      phone?: string | null;
      vatNumber?: string | null;
      marketingConsent: boolean;
      termsAccepted: boolean;
      capturedAt?: string | null;
      billingAddress?: {
        __typename?: 'OrderBillingAddress';
        street1: string;
        street2?: string | null;
        city: string;
        state?: string | null;
        postalCode: string;
        country: string;
        countryName?: string | null;
      } | null;
    };
  };
};

export type GetOrdersQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrdersQuery = {
  __typename?: 'Query';
  orders: Array<{
    __typename?: 'Order';
    id: string;
    orderNumber: string;
    userId: string;
    cartId: string;
    status: OrderStatus;
    paymentCurrency: string;
    exchangeRate: number;
    appliedCouponCode?: string | null;
    paymentHash: string;
    fulfillmentStatus: FulfillmentStatus;
    fulfillmentMetadata?: any | null;
    metadata?: any | null;
    completedAt?: string | null;
    cancelledAt?: string | null;
    expiresAt?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    items: Array<{
      __typename?: 'CartItem';
      productType: string;
      productId: string;
      quantity: number;
      unitPrice?: number | null;
      totalPrice?: number | null;
      name?: string | null;
      configuration?: {
        __typename?: 'CartItemConfiguration';
        initialBalance?: number | null;
        payoutFrequency?: number | null;
        leverage?: number | null;
        profitSplit?: number | null;
        addons: Array<string>;
        trackingModel?: string | null;
        trackingModelVersion?: string | null;
      } | null;
    }>;
    baseItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    appliedDiscount?: {
      __typename?: 'CouponDiscount';
      couponCodeRequested: string;
      couponCodeProcessed?: string | null;
      couponDiscount?: number | null;
      couponConfig?: {
        __typename?: 'CouponConfig';
        discountType: string;
        amountType: AmountType;
        amount: number;
      } | null;
    } | null;
    customerSnapshot: {
      __typename?: 'OrderCustomerSnapshot';
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      company?: string | null;
      phone?: string | null;
      vatNumber?: string | null;
      marketingConsent: boolean;
      termsAccepted: boolean;
      capturedAt?: string | null;
      billingAddress?: {
        __typename?: 'OrderBillingAddress';
        street1: string;
        street2?: string | null;
        city: string;
        state?: string | null;
        postalCode: string;
        country: string;
        countryName?: string | null;
      } | null;
    };
  }>;
};

export type GetPayoutMethodsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPayoutMethodsQuery = {
  __typename?: 'Query';
  payoutMethods: Array<{
    __typename?: 'PayoutMethod';
    id: string;
    type: PayoutMethodTypeEnum;
    name: string;
    displayName?: string | null;
    status: PayoutMethodStatusEnum;
    configuration: any;
  }>;
};

export type GetPayoutsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPayoutsQuery = {
  __typename?: 'Query';
  payouts: Array<{
    __typename?: 'Payout';
    status: PayoutStatusEnum;
    withdrawalAmount: number;
    createdAt: string;
  }>;
};

export type GetTradingAccountDailyMetricsQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;

export type GetTradingAccountDailyMetricsQuery = {
  __typename?: 'Query';
  tradingAccountDailyMetrics: Array<{
    __typename?: 'TradingAccountDailyMetrics';
    id?: number | null;
    tradingAccountId: string;
    year: number;
    month: number;
    day: number;
    startingBalance: number;
    startingEquity: number;
    endingBalance?: number | null;
    endingEquity?: number | null;
    tradesExecuted?: number | null;
    lotsExecuted?: number | null;
    withdrawals?: number | null;
    createdAt: string;
    note?: string | null;
  }>;
};

export type GetTradingAccountHistoryQueryVariables = Exact<{
  accountNumber: Scalars['String']['input'];
}>;

export type GetTradingAccountHistoryQuery = {
  __typename?: 'Query';
  tradingAccountHistory: Array<{
    __typename?: 'TradingAccountHistory';
    id?: string | null;
    tradingAccountId: string;
    positionId: string;
    platform?: string | null;
    symbol: string;
    dateOpenUtc: string;
    dateCloseUtc: string;
    holdTime: number;
    action: TradingAccountPositionAction;
    swaps: number;
    commissions: number;
    fees: number;
    lots: number;
    profit: number;
    profitPercentage: number;
    netProfit: number;
    openPrice: number;
    closePrice: number;
    note?: string | null;
  }>;
};

export type GetViewerQueryVariables = Exact<{ [key: string]: never }>;

export type GetViewerQuery = {
  __typename?: 'Query';
  viewer: {
    __typename?: 'LoginResponse';
    success: boolean;
    message: string;
    accessToken?: string | null;
    refreshToken?: string | null;
    clientIp: string;
    user?: {
      __typename?: 'UserInfo';
      id: string;
      email: string;
      roles: Array<string>;
      firstName?: string | null;
      middleName?: string | null;
      lastName?: string | null;
      preferredLocale?: string | null;
      countryCode?: string | null;
    } | null;
  };
};

export type RequestCartQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  paymentCurrency?: InputMaybe<Scalars['String']['input']>;
  utmData?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type RequestCartQuery = {
  __typename?: 'Query';
  cart: {
    __typename?: 'Cart';
    id: string;
    status: CartStatus;
    appliedCouponCode?: string | null;
    metadata: any;
    createdAt: string;
    updatedAt?: string | null;
    paymentCurrency: string;
    exchangeRate: number;
    items: Array<{
      __typename?: 'CartItem';
      productType: string;
      productId: string;
      quantity: number;
      unitPrice?: number | null;
      totalPrice?: number | null;
      name?: string | null;
      configuration?: {
        __typename?: 'CartItemConfiguration';
        initialBalance?: number | null;
        payoutFrequency?: number | null;
        leverage?: number | null;
        profitSplit?: number | null;
        addons: Array<string>;
        trackingModel?: string | null;
        trackingModelVersion?: string | null;
      } | null;
    }>;
    baseItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    baseFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentItemsTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentDiscountAmount: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    paymentFinalTotal: {
      __typename?: 'CurrencyAmount';
      amount: number;
      currency: string;
    };
    appliedDiscount?: {
      __typename?: 'CouponDiscount';
      couponCodeRequested: string;
      couponCodeProcessed?: string | null;
      couponDiscount?: number | null;
      couponConfig?: {
        __typename?: 'CouponConfig';
        discountType: string;
        amountType: AmountType;
        amount: number;
      } | null;
    } | null;
  };
};

export const CartItemConfigurationFragmentDoc = gql`
  fragment CartItemConfiguration on CartItemConfiguration {
    initialBalance
    payoutFrequency
    leverage
    profitSplit
    addons
    trackingModel
    trackingModelVersion
  }
`;
export const CartItemFragmentDoc = gql`
  fragment CartItem on CartItem {
    productType
    productId
    quantity
    unitPrice
    totalPrice
    name
    configuration {
      ...CartItemConfiguration
    }
  }
  ${CartItemConfigurationFragmentDoc}
`;
export const CurrencyAmountFragmentDoc = gql`
  fragment CurrencyAmount on CurrencyAmount {
    amount
    currency
  }
`;
export const CouponConfigFragmentDoc = gql`
  fragment CouponConfig on CouponConfig {
    discountType
    amountType
    amount
  }
`;
export const CouponDiscountFragmentDoc = gql`
  fragment CouponDiscount on CouponDiscount {
    couponCodeRequested
    couponCodeProcessed
    couponDiscount
    couponConfig {
      ...CouponConfig
    }
  }
  ${CouponConfigFragmentDoc}
`;
export const CartFragmentDoc = gql`
  fragment Cart on Cart {
    id
    status
    items {
      ...CartItem
    }
    baseItemsTotal {
      ...CurrencyAmount
    }
    baseDiscountAmount {
      ...CurrencyAmount
    }
    baseFinalTotal {
      ...CurrencyAmount
    }
    paymentItemsTotal {
      ...CurrencyAmount
    }
    paymentDiscountAmount {
      ...CurrencyAmount
    }
    paymentFinalTotal {
      ...CurrencyAmount
    }
    appliedCouponCode
    appliedDiscount {
      ...CouponDiscount
    }
    metadata
    createdAt
    updatedAt
    paymentCurrency
    exchangeRate
  }
  ${CartItemFragmentDoc}
  ${CurrencyAmountFragmentDoc}
  ${CouponDiscountFragmentDoc}
`;
export const UserInfoFragmentDoc = gql`
  fragment UserInfo on UserInfo {
    id
    email
    roles
    firstName
    middleName
    lastName
    preferredLocale
    countryCode
  }
`;
export const LoginResponseFragmentDoc = gql`
  fragment LoginResponse on LoginResponse {
    success
    message
    accessToken
    refreshToken
    user {
      ...UserInfo
    }
    clientIp
  }
  ${UserInfoFragmentDoc}
`;
export const PayoutFragmentDoc = gql`
  fragment Payout on Payout {
    status
    withdrawalAmount
    createdAt
  }
`;
export const OrderPaymentFragmentDoc = gql`
  fragment OrderPayment on OrderPayment {
    id
    orderId
    paymentReference
    sequenceNumber
    amount
    currency
    paymentGateway
    paymentProcessor
    paymentStatus
    gatewayStatus
    gatewayUrl
  }
`;
export const OrderBillingAddressFragmentDoc = gql`
  fragment OrderBillingAddress on OrderBillingAddress {
    street1
    street2
    city
    state
    postalCode
    country
    countryName
  }
`;
export const OrderCustomerSnapshotFragmentDoc = gql`
  fragment OrderCustomerSnapshot on OrderCustomerSnapshot {
    email
    firstName
    lastName
    company
    phone
    billingAddress {
      ...OrderBillingAddress
    }
    vatNumber
    marketingConsent
    termsAccepted
    capturedAt
  }
  ${OrderBillingAddressFragmentDoc}
`;
export const OrderFragmentDoc = gql`
  fragment Order on Order {
    id
    orderNumber
    userId
    cartId
    status
    items {
      ...CartItem
    }
    baseItemsTotal {
      ...CurrencyAmount
    }
    baseDiscountAmount {
      ...CurrencyAmount
    }
    baseFinalTotal {
      ...CurrencyAmount
    }
    paymentCurrency
    exchangeRate
    paymentItemsTotal {
      ...CurrencyAmount
    }
    paymentDiscountAmount {
      ...CurrencyAmount
    }
    paymentFinalTotal {
      ...CurrencyAmount
    }
    appliedCouponCode
    appliedDiscount {
      ...CouponDiscount
    }
    customerSnapshot {
      ...OrderCustomerSnapshot
    }
    paymentHash
    fulfillmentStatus
    fulfillmentMetadata
    metadata
    completedAt
    cancelledAt
    expiresAt
    createdAt
    updatedAt
  }
  ${CartItemFragmentDoc}
  ${CurrencyAmountFragmentDoc}
  ${CouponDiscountFragmentDoc}
  ${OrderCustomerSnapshotFragmentDoc}
`;
export const PlaceOrderResponseFragmentDoc = gql`
  fragment PlaceOrderResponse on PlaceOrderResponse {
    payment {
      ...OrderPayment
    }
    order {
      ...Order
    }
  }
  ${OrderPaymentFragmentDoc}
  ${OrderFragmentDoc}
`;
export const TradingAccountDailyMetricsFragmentDoc = gql`
  fragment TradingAccountDailyMetrics on TradingAccountDailyMetrics {
    id
    tradingAccountId
    year
    month
    day
    startingBalance
    startingEquity
    endingBalance
    endingEquity
    tradesExecuted
    lotsExecuted
    withdrawals
    createdAt
    note
  }
`;
export const TradingAccountHistoryFragmentDoc = gql`
  fragment TradingAccountHistory on TradingAccountHistory {
    id
    tradingAccountId
    positionId
    platform
    symbol
    dateOpenUtc
    dateCloseUtc
    holdTime
    action
    swaps
    commissions
    fees
    lots
    profit
    profitPercentage
    netProfit
    openPrice
    closePrice
    note
  }
`;
export const TradingAccountFragmentDoc = gql`
  fragment TradingAccount on TradingAccount {
    id
    name
    platform
    number
    initialBalance
    equity
    balance
    status
    trackingModel
    snapshot
    masterPassword
    investorPassword
    createdAt
    parameters {
      profitSplitAmount
      payoutFrequency
      leverage
    }
  }
`;
export const AcceptRiskTermsForAllocationDocument = gql`
  mutation AcceptRiskTermsForAllocation($input: AcceptRiskTermsInput!) {
    acceptRiskTerms(input: $input) {
      success
      message
    }
  }
`;
export type AcceptRiskTermsForAllocationMutationFn = Apollo.MutationFunction<
  AcceptRiskTermsForAllocationMutation,
  AcceptRiskTermsForAllocationMutationVariables
>;

/**
 * __useAcceptRiskTermsForAllocationMutation__
 *
 * To run a mutation, you first call `useAcceptRiskTermsForAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptRiskTermsForAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptRiskTermsForAllocationMutation, { data, loading, error }] = useAcceptRiskTermsForAllocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptRiskTermsForAllocationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptRiskTermsForAllocationMutation,
    AcceptRiskTermsForAllocationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptRiskTermsForAllocationMutation,
    AcceptRiskTermsForAllocationMutationVariables
  >(AcceptRiskTermsForAllocationDocument, options);
}
export type AcceptRiskTermsForAllocationMutationHookResult = ReturnType<
  typeof useAcceptRiskTermsForAllocationMutation
>;
export type AcceptRiskTermsForAllocationMutationResult =
  Apollo.MutationResult<AcceptRiskTermsForAllocationMutation>;
export type AcceptRiskTermsForAllocationMutationOptions =
  Apollo.BaseMutationOptions<
    AcceptRiskTermsForAllocationMutation,
    AcceptRiskTermsForAllocationMutationVariables
  >;
export const AddDiscountToCartDocument = gql`
  mutation AddDiscountToCart(
    $cartId: String
    $discountCode: String
    $paymentCurrency: String
    $utmData: JSON
  ) {
    addDiscountToCart(
      cartId: $cartId
      discountCode: $discountCode
      paymentCurrency: $paymentCurrency
      utmData: $utmData
    ) {
      ...Cart
    }
  }
  ${CartFragmentDoc}
`;
export type AddDiscountToCartMutationFn = Apollo.MutationFunction<
  AddDiscountToCartMutation,
  AddDiscountToCartMutationVariables
>;

/**
 * __useAddDiscountToCartMutation__
 *
 * To run a mutation, you first call `useAddDiscountToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDiscountToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDiscountToCartMutation, { data, loading, error }] = useAddDiscountToCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      discountCode: // value for 'discountCode'
 *      paymentCurrency: // value for 'paymentCurrency'
 *      utmData: // value for 'utmData'
 *   },
 * });
 */
export function useAddDiscountToCartMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddDiscountToCartMutation,
    AddDiscountToCartMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddDiscountToCartMutation,
    AddDiscountToCartMutationVariables
  >(AddDiscountToCartDocument, options);
}
export type AddDiscountToCartMutationHookResult = ReturnType<
  typeof useAddDiscountToCartMutation
>;
export type AddDiscountToCartMutationResult =
  Apollo.MutationResult<AddDiscountToCartMutation>;
export type AddDiscountToCartMutationOptions = Apollo.BaseMutationOptions<
  AddDiscountToCartMutation,
  AddDiscountToCartMutationVariables
>;
export const AddProductToCartDocument = gql`
  mutation AddProductToCart(
    $cartId: String
    $productId: String!
    $paymentCurrency: String
    $utmData: JSON
  ) {
    addProductToCart(
      cartId: $cartId
      productId: $productId
      paymentCurrency: $paymentCurrency
      utmData: $utmData
    ) {
      ...Cart
    }
  }
  ${CartFragmentDoc}
`;
export type AddProductToCartMutationFn = Apollo.MutationFunction<
  AddProductToCartMutation,
  AddProductToCartMutationVariables
>;

/**
 * __useAddProductToCartMutation__
 *
 * To run a mutation, you first call `useAddProductToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToCartMutation, { data, loading, error }] = useAddProductToCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      productId: // value for 'productId'
 *      paymentCurrency: // value for 'paymentCurrency'
 *      utmData: // value for 'utmData'
 *   },
 * });
 */
export function useAddProductToCartMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddProductToCartMutation,
    AddProductToCartMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddProductToCartMutation,
    AddProductToCartMutationVariables
  >(AddProductToCartDocument, options);
}
export type AddProductToCartMutationHookResult = ReturnType<
  typeof useAddProductToCartMutation
>;
export type AddProductToCartMutationResult =
  Apollo.MutationResult<AddProductToCartMutation>;
export type AddProductToCartMutationOptions = Apollo.BaseMutationOptions<
  AddProductToCartMutation,
  AddProductToCartMutationVariables
>;
export const CreateAccountWithdrawalDocument = gql`
  mutation CreateAccountWithdrawal($input: CreateAccountWithdrawalInput!) {
    createAccountWithdrawal(input: $input) {
      payoutId
      status
      withdrawalAmount
      totalToPayAmount
      profitSplitAmount
      message
    }
  }
`;
export type CreateAccountWithdrawalMutationFn = Apollo.MutationFunction<
  CreateAccountWithdrawalMutation,
  CreateAccountWithdrawalMutationVariables
>;

/**
 * __useCreateAccountWithdrawalMutation__
 *
 * To run a mutation, you first call `useCreateAccountWithdrawalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountWithdrawalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountWithdrawalMutation, { data, loading, error }] = useCreateAccountWithdrawalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountWithdrawalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAccountWithdrawalMutation,
    CreateAccountWithdrawalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAccountWithdrawalMutation,
    CreateAccountWithdrawalMutationVariables
  >(CreateAccountWithdrawalDocument, options);
}
export type CreateAccountWithdrawalMutationHookResult = ReturnType<
  typeof useCreateAccountWithdrawalMutation
>;
export type CreateAccountWithdrawalMutationResult =
  Apollo.MutationResult<CreateAccountWithdrawalMutation>;
export type CreateAccountWithdrawalMutationOptions = Apollo.BaseMutationOptions<
  CreateAccountWithdrawalMutation,
  CreateAccountWithdrawalMutationVariables
>;
export const CreatePayoutMethodDocument = gql`
  mutation CreatePayoutMethod($input: CreatePayoutMethodInput!) {
    createPayoutMethod(input: $input) {
      id
      type
      name
      displayName
      status
      isDefault
      configuration
      createdAt
    }
  }
`;
export type CreatePayoutMethodMutationFn = Apollo.MutationFunction<
  CreatePayoutMethodMutation,
  CreatePayoutMethodMutationVariables
>;

/**
 * __useCreatePayoutMethodMutation__
 *
 * To run a mutation, you first call `useCreatePayoutMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayoutMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayoutMethodMutation, { data, loading, error }] = useCreatePayoutMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayoutMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePayoutMethodMutation,
    CreatePayoutMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePayoutMethodMutation,
    CreatePayoutMethodMutationVariables
  >(CreatePayoutMethodDocument, options);
}
export type CreatePayoutMethodMutationHookResult = ReturnType<
  typeof useCreatePayoutMethodMutation
>;
export type CreatePayoutMethodMutationResult =
  Apollo.MutationResult<CreatePayoutMethodMutation>;
export type CreatePayoutMethodMutationOptions = Apollo.BaseMutationOptions<
  CreatePayoutMethodMutation,
  CreatePayoutMethodMutationVariables
>;
export const ImpersonateUserDocument = gql`
  mutation ImpersonateUser($username: String!) {
    impersonate(username: $username) {
      ...LoginResponse
    }
  }
  ${LoginResponseFragmentDoc}
`;
export type ImpersonateUserMutationFn = Apollo.MutationFunction<
  ImpersonateUserMutation,
  ImpersonateUserMutationVariables
>;

/**
 * __useImpersonateUserMutation__
 *
 * To run a mutation, you first call `useImpersonateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateUserMutation, { data, loading, error }] = useImpersonateUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useImpersonateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImpersonateUserMutation,
    ImpersonateUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ImpersonateUserMutation,
    ImpersonateUserMutationVariables
  >(ImpersonateUserDocument, options);
}
export type ImpersonateUserMutationHookResult = ReturnType<
  typeof useImpersonateUserMutation
>;
export type ImpersonateUserMutationResult =
  Apollo.MutationResult<ImpersonateUserMutation>;
export type ImpersonateUserMutationOptions = Apollo.BaseMutationOptions<
  ImpersonateUserMutation,
  ImpersonateUserMutationVariables
>;
export const LoginUserDocument = gql`
  mutation LoginUser($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      ...LoginResponse
    }
  }
  ${LoginResponseFragmentDoc}
`;
export type LoginUserMutationFn = Apollo.MutationFunction<
  LoginUserMutation,
  LoginUserMutationVariables
>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginUserMutation,
    LoginUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginUserMutation, LoginUserMutationVariables>(
    LoginUserDocument,
    options,
  );
}
export type LoginUserMutationHookResult = ReturnType<
  typeof useLoginUserMutation
>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<
  LoginUserMutation,
  LoginUserMutationVariables
>;
export const PlaceOrderDocument = gql`
  mutation PlaceOrder(
    $cartId: ID!
    $customerSnapshot: OrderCustomerSnapshotInput!
    $paymentGateway: PaymentGatewayEnum
    $affiliateCode: String
    $adminOrder: Boolean
  ) {
    placeOrder(
      cartId: $cartId
      customerSnapshot: $customerSnapshot
      paymentGateway: $paymentGateway
      affiliateCode: $affiliateCode
      adminOrder: $adminOrder
    ) {
      ...PlaceOrderResponse
    }
  }
  ${PlaceOrderResponseFragmentDoc}
`;
export type PlaceOrderMutationFn = Apollo.MutationFunction<
  PlaceOrderMutation,
  PlaceOrderMutationVariables
>;

/**
 * __usePlaceOrderMutation__
 *
 * To run a mutation, you first call `usePlaceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeOrderMutation, { data, loading, error }] = usePlaceOrderMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      customerSnapshot: // value for 'customerSnapshot'
 *      paymentGateway: // value for 'paymentGateway'
 *      affiliateCode: // value for 'affiliateCode'
 *      adminOrder: // value for 'adminOrder'
 *   },
 * });
 */
export function usePlaceOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PlaceOrderMutation,
    PlaceOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PlaceOrderMutation, PlaceOrderMutationVariables>(
    PlaceOrderDocument,
    options,
  );
}
export type PlaceOrderMutationHookResult = ReturnType<
  typeof usePlaceOrderMutation
>;
export type PlaceOrderMutationResult =
  Apollo.MutationResult<PlaceOrderMutation>;
export type PlaceOrderMutationOptions = Apollo.BaseMutationOptions<
  PlaceOrderMutation,
  PlaceOrderMutationVariables
>;
export const RegisterUserDocument = gql`
  mutation RegisterUser($input: RegisterUserInput!) {
    register(input: $input) {
      ...LoginResponse
    }
  }
  ${LoginResponseFragmentDoc}
`;
export type RegisterUserMutationFn = Apollo.MutationFunction<
  RegisterUserMutation,
  RegisterUserMutationVariables
>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterUserMutation,
    RegisterUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterUserMutation,
    RegisterUserMutationVariables
  >(RegisterUserDocument, options);
}
export type RegisterUserMutationHookResult = ReturnType<
  typeof useRegisterUserMutation
>;
export type RegisterUserMutationResult =
  Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<
  RegisterUserMutation,
  RegisterUserMutationVariables
>;
export const RenewInstantFundingDocument = gql`
  mutation RenewInstantFunding(
    $accountNumber: String!
    $paymentGateway: PaymentGatewayEnum!
    $paymentHash: String
  ) {
    renewInstantFunding(
      accountNumber: $accountNumber
      paymentGateway: $paymentGateway
      paymentHash: $paymentHash
    ) {
      ...PlaceOrderResponse
    }
  }
  ${PlaceOrderResponseFragmentDoc}
`;
export type RenewInstantFundingMutationFn = Apollo.MutationFunction<
  RenewInstantFundingMutation,
  RenewInstantFundingMutationVariables
>;

/**
 * __useRenewInstantFundingMutation__
 *
 * To run a mutation, you first call `useRenewInstantFundingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewInstantFundingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewInstantFundingMutation, { data, loading, error }] = useRenewInstantFundingMutation({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *      paymentGateway: // value for 'paymentGateway'
 *      paymentHash: // value for 'paymentHash'
 *   },
 * });
 */
export function useRenewInstantFundingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenewInstantFundingMutation,
    RenewInstantFundingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RenewInstantFundingMutation,
    RenewInstantFundingMutationVariables
  >(RenewInstantFundingDocument, options);
}
export type RenewInstantFundingMutationHookResult = ReturnType<
  typeof useRenewInstantFundingMutation
>;
export type RenewInstantFundingMutationResult =
  Apollo.MutationResult<RenewInstantFundingMutation>;
export type RenewInstantFundingMutationOptions = Apollo.BaseMutationOptions<
  RenewInstantFundingMutation,
  RenewInstantFundingMutationVariables
>;
export const RequestPasswordResetDocument = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email) {
      success
      message
    }
  }
`;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables
>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestPasswordResetMutation,
    RequestPasswordResetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestPasswordResetMutation,
    RequestPasswordResetMutationVariables
  >(RequestPasswordResetDocument, options);
}
export type RequestPasswordResetMutationHookResult = ReturnType<
  typeof useRequestPasswordResetMutation
>;
export type RequestPasswordResetMutationResult =
  Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<
  RequestPasswordResetMutation,
  RequestPasswordResetMutationVariables
>;
export const RequestPaymentForOrderDocument = gql`
  mutation RequestPaymentForOrder(
    $orderNumber: String!
    $paymentGateway: PaymentGatewayEnum!
    $paymentHash: String
  ) {
    requestPaymentForOrder(
      orderNumber: $orderNumber
      paymentGateway: $paymentGateway
      paymentHash: $paymentHash
    ) {
      ...PlaceOrderResponse
    }
  }
  ${PlaceOrderResponseFragmentDoc}
`;
export type RequestPaymentForOrderMutationFn = Apollo.MutationFunction<
  RequestPaymentForOrderMutation,
  RequestPaymentForOrderMutationVariables
>;

/**
 * __useRequestPaymentForOrderMutation__
 *
 * To run a mutation, you first call `useRequestPaymentForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPaymentForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPaymentForOrderMutation, { data, loading, error }] = useRequestPaymentForOrderMutation({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      paymentGateway: // value for 'paymentGateway'
 *      paymentHash: // value for 'paymentHash'
 *   },
 * });
 */
export function useRequestPaymentForOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestPaymentForOrderMutation,
    RequestPaymentForOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestPaymentForOrderMutation,
    RequestPaymentForOrderMutationVariables
  >(RequestPaymentForOrderDocument, options);
}
export type RequestPaymentForOrderMutationHookResult = ReturnType<
  typeof useRequestPaymentForOrderMutation
>;
export type RequestPaymentForOrderMutationResult =
  Apollo.MutationResult<RequestPaymentForOrderMutation>;
export type RequestPaymentForOrderMutationOptions = Apollo.BaseMutationOptions<
  RequestPaymentForOrderMutation,
  RequestPaymentForOrderMutationVariables
>;
export const ResetPasswordDocument = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      ...LoginResponse
    }
  }
  ${LoginResponseFragmentDoc}
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >(ResetPasswordDocument, options);
}
export type ResetPasswordMutationHookResult = ReturnType<
  typeof useResetPasswordMutation
>;
export type ResetPasswordMutationResult =
  Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const StartKycSessionDocument = gql`
  mutation StartKYCSession($input: StartKYCInput!) {
    startKYCSession(input: $input) {
      success
      message
      redirectUrl
    }
  }
`;
export type StartKycSessionMutationFn = Apollo.MutationFunction<
  StartKycSessionMutation,
  StartKycSessionMutationVariables
>;

/**
 * __useStartKycSessionMutation__
 *
 * To run a mutation, you first call `useStartKycSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartKycSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startKycSessionMutation, { data, loading, error }] = useStartKycSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartKycSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartKycSessionMutation,
    StartKycSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartKycSessionMutation,
    StartKycSessionMutationVariables
  >(StartKycSessionDocument, options);
}
export type StartKycSessionMutationHookResult = ReturnType<
  typeof useStartKycSessionMutation
>;
export type StartKycSessionMutationResult =
  Apollo.MutationResult<StartKycSessionMutation>;
export type StartKycSessionMutationOptions = Apollo.BaseMutationOptions<
  StartKycSessionMutation,
  StartKycSessionMutationVariables
>;
export const ValidatePasswordResetTokenDocument = gql`
  mutation validatePasswordResetToken($token: String!) {
    validatePasswordResetToken(token: $token) {
      success
      message
    }
  }
`;
export type ValidatePasswordResetTokenMutationFn = Apollo.MutationFunction<
  ValidatePasswordResetTokenMutation,
  ValidatePasswordResetTokenMutationVariables
>;

/**
 * __useValidatePasswordResetTokenMutation__
 *
 * To run a mutation, you first call `useValidatePasswordResetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordResetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePasswordResetTokenMutation, { data, loading, error }] = useValidatePasswordResetTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidatePasswordResetTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidatePasswordResetTokenMutation,
    ValidatePasswordResetTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidatePasswordResetTokenMutation,
    ValidatePasswordResetTokenMutationVariables
  >(ValidatePasswordResetTokenDocument, options);
}
export type ValidatePasswordResetTokenMutationHookResult = ReturnType<
  typeof useValidatePasswordResetTokenMutation
>;
export type ValidatePasswordResetTokenMutationResult =
  Apollo.MutationResult<ValidatePasswordResetTokenMutation>;
export type ValidatePasswordResetTokenMutationOptions =
  Apollo.BaseMutationOptions<
    ValidatePasswordResetTokenMutation,
    ValidatePasswordResetTokenMutationVariables
  >;
export const ChatAuthDocument = gql`
  query ChatAuth {
    authorizeTradingAi {
      token
    }
  }
`;

/**
 * __useChatAuthQuery__
 *
 * To run a query within a React component, call `useChatAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatAuthQuery(
  baseOptions?: Apollo.QueryHookOptions<ChatAuthQuery, ChatAuthQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChatAuthQuery, ChatAuthQueryVariables>(
    ChatAuthDocument,
    options,
  );
}
export function useChatAuthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChatAuthQuery,
    ChatAuthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChatAuthQuery, ChatAuthQueryVariables>(
    ChatAuthDocument,
    options,
  );
}
export type ChatAuthQueryHookResult = ReturnType<typeof useChatAuthQuery>;
export type ChatAuthLazyQueryHookResult = ReturnType<
  typeof useChatAuthLazyQuery
>;
export type ChatAuthQueryResult = Apollo.QueryResult<
  ChatAuthQuery,
  ChatAuthQueryVariables
>;
export const GetBrokerAccountDocument = gql`
  query GetBrokerAccount($accountNumber: String!) {
    tradingAccount(accountNumber: $accountNumber) {
      ...TradingAccount
    }
  }
  ${TradingAccountFragmentDoc}
`;

/**
 * __useGetBrokerAccountQuery__
 *
 * To run a query within a React component, call `useGetBrokerAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerAccountQuery({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *   },
 * });
 */
export function useGetBrokerAccountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBrokerAccountQuery,
    GetBrokerAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBrokerAccountQuery, GetBrokerAccountQueryVariables>(
    GetBrokerAccountDocument,
    options,
  );
}
export function useGetBrokerAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBrokerAccountQuery,
    GetBrokerAccountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBrokerAccountQuery,
    GetBrokerAccountQueryVariables
  >(GetBrokerAccountDocument, options);
}
export type GetBrokerAccountQueryHookResult = ReturnType<
  typeof useGetBrokerAccountQuery
>;
export type GetBrokerAccountLazyQueryHookResult = ReturnType<
  typeof useGetBrokerAccountLazyQuery
>;
export type GetBrokerAccountQueryResult = Apollo.QueryResult<
  GetBrokerAccountQuery,
  GetBrokerAccountQueryVariables
>;
export const GetBrokerAccountsDocument = gql`
  query GetBrokerAccounts {
    tradingAccounts {
      ...TradingAccount
    }
  }
  ${TradingAccountFragmentDoc}
`;

/**
 * __useGetBrokerAccountsQuery__
 *
 * To run a query within a React component, call `useGetBrokerAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrokerAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBrokerAccountsQuery,
    GetBrokerAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBrokerAccountsQuery,
    GetBrokerAccountsQueryVariables
  >(GetBrokerAccountsDocument, options);
}
export function useGetBrokerAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBrokerAccountsQuery,
    GetBrokerAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBrokerAccountsQuery,
    GetBrokerAccountsQueryVariables
  >(GetBrokerAccountsDocument, options);
}
export type GetBrokerAccountsQueryHookResult = ReturnType<
  typeof useGetBrokerAccountsQuery
>;
export type GetBrokerAccountsLazyQueryHookResult = ReturnType<
  typeof useGetBrokerAccountsLazyQuery
>;
export type GetBrokerAccountsQueryResult = Apollo.QueryResult<
  GetBrokerAccountsQuery,
  GetBrokerAccountsQueryVariables
>;
export const GetSpecificKycStatusDocument = gql`
  query GetSpecificKYCStatus($verificationId: ID!) {
    getKYCStatus(verificationId: $verificationId) {
      verificationId
      status
      canStartSession
      createdAt
      completedAt
    }
  }
`;

/**
 * __useGetSpecificKycStatusQuery__
 *
 * To run a query within a React component, call `useGetSpecificKycStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecificKycStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecificKycStatusQuery({
 *   variables: {
 *      verificationId: // value for 'verificationId'
 *   },
 * });
 */
export function useGetSpecificKycStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSpecificKycStatusQuery,
    GetSpecificKycStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSpecificKycStatusQuery,
    GetSpecificKycStatusQueryVariables
  >(GetSpecificKycStatusDocument, options);
}
export function useGetSpecificKycStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSpecificKycStatusQuery,
    GetSpecificKycStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSpecificKycStatusQuery,
    GetSpecificKycStatusQueryVariables
  >(GetSpecificKycStatusDocument, options);
}
export type GetSpecificKycStatusQueryHookResult = ReturnType<
  typeof useGetSpecificKycStatusQuery
>;
export type GetSpecificKycStatusLazyQueryHookResult = ReturnType<
  typeof useGetSpecificKycStatusLazyQuery
>;
export type GetSpecificKycStatusQueryResult = Apollo.QueryResult<
  GetSpecificKycStatusQuery,
  GetSpecificKycStatusQueryVariables
>;
export const GetOrderDocument = gql`
  query GetOrder($orderNumber: String!, $paymentHash: String) {
    order(orderNumber: $orderNumber, paymentHash: $paymentHash) {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *      paymentHash: // value for 'paymentHash'
 *   },
 * });
 */
export function useGetOrderQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(
    GetOrderDocument,
    options,
  );
}
export function useGetOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrderQuery,
    GetOrderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(
    GetOrderDocument,
    options,
  );
}
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<
  typeof useGetOrderLazyQuery
>;
export type GetOrderQueryResult = Apollo.QueryResult<
  GetOrderQuery,
  GetOrderQueryVariables
>;
export const GetOrdersDocument = gql`
  query GetOrders {
    orders {
      ...Order
    }
  }
  ${OrderFragmentDoc}
`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrdersQuery,
    GetOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(
    GetOrdersDocument,
    options,
  );
}
export function useGetOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrdersQuery,
    GetOrdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(
    GetOrdersDocument,
    options,
  );
}
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<
  typeof useGetOrdersLazyQuery
>;
export type GetOrdersQueryResult = Apollo.QueryResult<
  GetOrdersQuery,
  GetOrdersQueryVariables
>;
export const GetPayoutMethodsDocument = gql`
  query GetPayoutMethods {
    payoutMethods {
      id
      type
      name
      displayName
      status
      configuration
      configuration
    }
  }
`;

/**
 * __useGetPayoutMethodsQuery__
 *
 * To run a query within a React component, call `useGetPayoutMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutMethodsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPayoutMethodsQuery,
    GetPayoutMethodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPayoutMethodsQuery, GetPayoutMethodsQueryVariables>(
    GetPayoutMethodsDocument,
    options,
  );
}
export function useGetPayoutMethodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPayoutMethodsQuery,
    GetPayoutMethodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPayoutMethodsQuery,
    GetPayoutMethodsQueryVariables
  >(GetPayoutMethodsDocument, options);
}
export type GetPayoutMethodsQueryHookResult = ReturnType<
  typeof useGetPayoutMethodsQuery
>;
export type GetPayoutMethodsLazyQueryHookResult = ReturnType<
  typeof useGetPayoutMethodsLazyQuery
>;
export type GetPayoutMethodsQueryResult = Apollo.QueryResult<
  GetPayoutMethodsQuery,
  GetPayoutMethodsQueryVariables
>;
export const GetPayoutsDocument = gql`
  query GetPayouts {
    payouts {
      ...Payout
    }
  }
  ${PayoutFragmentDoc}
`;

/**
 * __useGetPayoutsQuery__
 *
 * To run a query within a React component, call `useGetPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPayoutsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPayoutsQuery,
    GetPayoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPayoutsQuery, GetPayoutsQueryVariables>(
    GetPayoutsDocument,
    options,
  );
}
export function useGetPayoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPayoutsQuery,
    GetPayoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPayoutsQuery, GetPayoutsQueryVariables>(
    GetPayoutsDocument,
    options,
  );
}
export type GetPayoutsQueryHookResult = ReturnType<typeof useGetPayoutsQuery>;
export type GetPayoutsLazyQueryHookResult = ReturnType<
  typeof useGetPayoutsLazyQuery
>;
export type GetPayoutsQueryResult = Apollo.QueryResult<
  GetPayoutsQuery,
  GetPayoutsQueryVariables
>;
export const GetTradingAccountDailyMetricsDocument = gql`
  query GetTradingAccountDailyMetrics($accountNumber: String!) {
    tradingAccountDailyMetrics(accountNumber: $accountNumber) {
      ...TradingAccountDailyMetrics
    }
  }
  ${TradingAccountDailyMetricsFragmentDoc}
`;

/**
 * __useGetTradingAccountDailyMetricsQuery__
 *
 * To run a query within a React component, call `useGetTradingAccountDailyMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTradingAccountDailyMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTradingAccountDailyMetricsQuery({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *   },
 * });
 */
export function useGetTradingAccountDailyMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTradingAccountDailyMetricsQuery,
    GetTradingAccountDailyMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTradingAccountDailyMetricsQuery,
    GetTradingAccountDailyMetricsQueryVariables
  >(GetTradingAccountDailyMetricsDocument, options);
}
export function useGetTradingAccountDailyMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTradingAccountDailyMetricsQuery,
    GetTradingAccountDailyMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTradingAccountDailyMetricsQuery,
    GetTradingAccountDailyMetricsQueryVariables
  >(GetTradingAccountDailyMetricsDocument, options);
}
export type GetTradingAccountDailyMetricsQueryHookResult = ReturnType<
  typeof useGetTradingAccountDailyMetricsQuery
>;
export type GetTradingAccountDailyMetricsLazyQueryHookResult = ReturnType<
  typeof useGetTradingAccountDailyMetricsLazyQuery
>;
export type GetTradingAccountDailyMetricsQueryResult = Apollo.QueryResult<
  GetTradingAccountDailyMetricsQuery,
  GetTradingAccountDailyMetricsQueryVariables
>;
export const GetTradingAccountHistoryDocument = gql`
  query GetTradingAccountHistory($accountNumber: String!) {
    tradingAccountHistory(accountNumber: $accountNumber) {
      ...TradingAccountHistory
    }
  }
  ${TradingAccountHistoryFragmentDoc}
`;

/**
 * __useGetTradingAccountHistoryQuery__
 *
 * To run a query within a React component, call `useGetTradingAccountHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTradingAccountHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTradingAccountHistoryQuery({
 *   variables: {
 *      accountNumber: // value for 'accountNumber'
 *   },
 * });
 */
export function useGetTradingAccountHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTradingAccountHistoryQuery,
    GetTradingAccountHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTradingAccountHistoryQuery,
    GetTradingAccountHistoryQueryVariables
  >(GetTradingAccountHistoryDocument, options);
}
export function useGetTradingAccountHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTradingAccountHistoryQuery,
    GetTradingAccountHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTradingAccountHistoryQuery,
    GetTradingAccountHistoryQueryVariables
  >(GetTradingAccountHistoryDocument, options);
}
export type GetTradingAccountHistoryQueryHookResult = ReturnType<
  typeof useGetTradingAccountHistoryQuery
>;
export type GetTradingAccountHistoryLazyQueryHookResult = ReturnType<
  typeof useGetTradingAccountHistoryLazyQuery
>;
export type GetTradingAccountHistoryQueryResult = Apollo.QueryResult<
  GetTradingAccountHistoryQuery,
  GetTradingAccountHistoryQueryVariables
>;
export const GetViewerDocument = gql`
  query GetViewer {
    viewer {
      ...LoginResponse
    }
  }
  ${LoginResponseFragmentDoc}
`;

/**
 * __useGetViewerQuery__
 *
 * To run a query within a React component, call `useGetViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetViewerQuery,
    GetViewerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetViewerQuery, GetViewerQueryVariables>(
    GetViewerDocument,
    options,
  );
}
export function useGetViewerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetViewerQuery,
    GetViewerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetViewerQuery, GetViewerQueryVariables>(
    GetViewerDocument,
    options,
  );
}
export type GetViewerQueryHookResult = ReturnType<typeof useGetViewerQuery>;
export type GetViewerLazyQueryHookResult = ReturnType<
  typeof useGetViewerLazyQuery
>;
export type GetViewerQueryResult = Apollo.QueryResult<
  GetViewerQuery,
  GetViewerQueryVariables
>;
export const RequestCartDocument = gql`
  query RequestCart($id: ID, $paymentCurrency: String, $utmData: JSON) {
    cart(id: $id, paymentCurrency: $paymentCurrency, utmData: $utmData) {
      ...Cart
    }
  }
  ${CartFragmentDoc}
`;

/**
 * __useRequestCartQuery__
 *
 * To run a query within a React component, call `useRequestCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestCartQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paymentCurrency: // value for 'paymentCurrency'
 *      utmData: // value for 'utmData'
 *   },
 * });
 */
export function useRequestCartQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RequestCartQuery,
    RequestCartQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RequestCartQuery, RequestCartQueryVariables>(
    RequestCartDocument,
    options,
  );
}
export function useRequestCartLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RequestCartQuery,
    RequestCartQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RequestCartQuery, RequestCartQueryVariables>(
    RequestCartDocument,
    options,
  );
}
export type RequestCartQueryHookResult = ReturnType<typeof useRequestCartQuery>;
export type RequestCartLazyQueryHookResult = ReturnType<
  typeof useRequestCartLazyQuery
>;
export type RequestCartQueryResult = Apollo.QueryResult<
  RequestCartQuery,
  RequestCartQueryVariables
>;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {},
};
export default result;

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  JSON: { input: any; output: any };
  _FieldSet: { input: any; output: any };
};

export type AcceptRiskTermsInput = {
  /**  Whether the user accepts (true) or declines (false) the risk terms */
  accepted: Scalars['Boolean']['input'];
  /**  The ID of the allocation request */
  allocationRequestId: Scalars['String']['input'];
};

/** Type of discount amount */
export enum AmountType {
  /** Percentage discount (e.g., 10 for 10%) */
  Percent = 'PERCENT',
}

export enum CartStatus {
  /** Cart is active and can be modified */
  Active = 'ACTIVE',
  /** Cart is completed and cannot be modified */
  Completed = 'COMPLETED',
}

export type CreateAccountWithdrawalInput = {
  accountNumber: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  payoutMethodId: Scalars['ID']['input'];
  platform: TradingAccountPlatformEnum;
};

export type CreatePayoutMethodInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  metadata: Scalars['JSON']['input'];
  type: PayoutMethodTypeEnum;
};

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests
   * Error Type: UNAVAILABLE
   */
  TooManyRequests = 'TOO_MANY_REQUESTS',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN',
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN',
}

export enum FulfillmentStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
}

export type OrderBillingAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  countryName?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCustomerSnapshotInput = {
  billingAddress?: InputMaybe<OrderBillingAddressInput>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  termsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
}

export enum PaymentGatewayEnum {
  Card = 'CARD',
  Crypto = 'CRYPTO',
}

export enum PaymentStatusEnum {
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Paid = 'PAID',
  Pending = 'PENDING',
}

export enum PayoutMethodStatusEnum {
  Archived = 'ARCHIVED',
  PendingVerification = 'PENDING_VERIFICATION',
  Suspended = 'SUSPENDED',
  VerificationFailed = 'VERIFICATION_FAILED',
  Verified = 'VERIFIED',
}

export enum PayoutMethodTypeEnum {
  CryptoWallet = 'CRYPTO_WALLET',
  Riseworks = 'RISEWORKS',
}

export enum PayoutStatusEnum {
  Approved = 'APPROVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  TransactionPending = 'TRANSACTION_PENDING',
  TransactionSubmitted = 'TRANSACTION_SUBMITTED',
}

export type RegisterUserInput = {
  /**  Defaults to "en" if not provided */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /**  Optional password - will be generated if not provided */
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  preferredLocale?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type StartKycInput = {
  firstName: Scalars['String']['input'];
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
  verificationId: Scalars['ID']['input'];
};

export enum TradingAccountPayoutStatusEnum {
  AwaitingApproval = 'AWAITING_APPROVAL',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
}

export enum TradingAccountPlatformEnum {
  Metatrader_5 = 'METATRADER_5',
}

export enum TradingAccountPositionAction {
  Buy = 'BUY',
  Sell = 'SELL',
}

export enum TradingAccountStatusEnum {
  Error = 'ERROR',
  Failed = 'FAILED',
  Passed = 'PASSED',
  PendingHistoryLoad = 'PENDING_HISTORY_LOAD',
  Running = 'RUNNING',
  SoftBreached = 'SOFT_BREACHED',
}
